import dayjs from '../plugins/dayjs';
// eslint-disable-next-line import/prefer-default-export
export const listCaptures = {
  data: () => ({
    captures: [],
    capturesSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: '-createdAt',
      dateType: 'captureDate',
      startDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endDate: dayjs().subtract(1, 'month').endOf('month').format(),
      dynamicSearch: '',
    },
    capturesLoading: true,
    capturesListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    captures() {
      this.capturesLoading = false;
    },
  },
  methods: {

    async listCaptures() {
      this.capturesLoading = true;
      const { data, headers, errorCode } = await this.$store.dispatch('charges/listCharges', { ...this.capturesSearchObject, status: ['captured', 'refunded'] });
      if (data) {
        this.captures = data;
      }
      if (errorCode) {
        this.capturesLoading = false;
      }
      this.capturesListInfo = this.formatHeaders(headers);
    },
    formatHeaders(headers) {
      if (!headers) return {};
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};
